import React from 'react';
import { AssetsPreviewSection } from '../../shared';
import { AssetsPreviewItems } from '../AssetsPreviewItems';
import { Asset } from '@/types/shared/asset.types';

interface GridViewProps {
  assets: Asset[];
  isRequiredAttention: boolean;
}
export const GridView = ({ assets, isRequiredAttention }: GridViewProps) => {
  return (
    <AssetsPreviewSection isRequiredAttention={isRequiredAttention} count={assets.length}>
      <AssetsPreviewItems isRequiredAttention={isRequiredAttention} items={assets} />
    </AssetsPreviewSection>
  );
};
